module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-89.952ed781.svg";